import {
  formatDateTime,
  imgMap,
  colorMap,
} from '@/utils';

export default {
  name: 'myInvite',
  data() {
    return {
      startTime: new Date(),
      endTime: new Date(),
      imgMap,
      colorMap,
      tableLoading: true,
      // coinList: [],
      pagination: { // 翻页数据
        count: 0, // 总数量
        pageSize: 10, // 每页显示条数
        page: 1, // 当前页数
      },
      tableType: 'list',
      selectCoin: '', // 选择的币种 BTC
      totalRewardAmount: '', // 邀请收入总金额
      invitationUserCount: '', // 邀请总人数
      inviteUrl: '', // 邀请链接URL
      inviteCode: '', // 邀请码
      rewardCoinSymbol: '', // 邀请奖励币种 BTC
      rewardCoinSymbolList: [], // 邀请奖励币种下拉列表  'BTC', 'VDUST',
      miningGrantAmountByInvitation: null,
      miningGrantSymbol: '',
      dataList: [],
      list: [
        // {
        //   registerUid: 12222,
        //   registerTime: 1628251867039,
        //   rewardAmount: 99,
        //   rewardCoinSymbol: 'VDUST',
        //   sendRewardStatus: 0,
        //   kycStatus: 'Y',
        //   userName: 'AAAA',
        // },
        // {
        //   registerUid: 333333,
        //   registerTime: 1628251867039,
        //   rewardAmount: 100,
        //   rewardCoinSymbol: 'BTC',
        //   sendRewardStatus: 1,
        //   kycStatus: 'F',
        //   userName: 'AAAA',
        // },
      ],
    };
  },
  computed: {
    coinList() {
      const arr = [];
      this.rewardCoinSymbolList.forEach((item) => {
        arr.push({
          label: item,
          value: item,
        });
      });
      return arr;
    },
    columns() {
      if (this.tableType === 'list') {
        return [
          {
            title: 'UID', // 'UID',
            width: '10%',
          },
          {
            title: `${this.$t('personal.myInvite.user')}`, // '用户名',
            width: '20%',
          },
          {
            title: 'KYC', // 'kyc',
            width: '10%',
          },
          {
            title: `${this.$t('personal.myInvite.status')}`, // `发放状态`,
            width: '20%',
          },
          {
            title: `${this.$t('personal.myInvite.myReward')}`, // `收入`,
            width: '10 %',
          },
          {
            title: `${this.$t('common.coin')}`, // `币种`,
            width: '10%',
          },
          {
            title: `${this.$t('personal.myInvite.time')}`, // `注册时间`,
            width: '20%',
          },
        ];
      }
      return [
        {
          title: 'UID', // 'UID',
          width: '10%',
        },
        {
          title: `${this.$t('personal.myInvite.user')}`, // '用户名',
          width: '20%',
        },
        {
          title: 'KYC', // 'kyc',
          width: '10%',
        },
        {
          title: `${this.$t('personal.myInvite.miningDetails', { coin: this.rewardCoinSymbol })}`, // `挖矿明细`,
          width: '20%',
        },
        {
          title: `${this.$t('personal.myInvite.miningRewards', { coin: this.rewardCoinSymbol })}`, // `邀请奖励`,
          width: '10%',
      },
        {
          title: `${this.$t('personal.myInvite.time')}`, // `注册时间`,
          width: '20%',
        },
      ];
    },
  },
  methods: {
    init() {
      this.getOverview();
      this.getList();
      // this.tableLoading = false;
      // this.onSolveList(this.list, 0);
    },
    // 搜索
    onSearch() {
      this.tableLoading = true;
      this.getOverview();
      this.getList();
    },
    // 复制
    copyClick(val) {
      let str = '';
      if (val === 'code') {
        str = this.inviteCode;
      } else {
        str = this.inviteUrl;
      }
      this.$bus.$emit('tip', { text: this.$t('personal.prompt.copySucces'), type: 'success' });
      function save(e) {
        e.clipboardData.setData('text/plain', str); // 下面会说到clipboardData对象
        e.preventDefault(); // 阻止默认行为
      }
      document.addEventListener('copy', save);
      document.execCommand('copy'); // 使文档处于可编辑状态，否则无效
      document.removeEventListener('copy', save);
    },
    // tab切换
    onTabChange(val) {
      // this.tableType = val;
      if (val === 'list') {
        this.getList();
      } else {
        let url = 'https://www.vdollar.online/zh_CN/mining';
        // 修改url为当前一级域名
        const tempDomain = document.domain.split('.').slice(-1).join();
        const keyDomain = url.split('.').slice(-1).join().split('/')
          .slice(0, 1)
          .join();
        if (tempDomain !== keyDomain) {
          url = url.replace(new RegExp(keyDomain, 'g'), tempDomain);
        }
        window.open(url);
      }
    },
    // 总览数据
    getOverview() {
      const pa = {};
      if (this.rewardCoinSymbol) {
        pa.rewardCoinSymbol = this.selectCoin;
      }
      this.axios({
        url: '/invitation/invitation_overview',
        params: pa,
      }).then((data) => {
        if (data.code.toString() === '0') {
          this.totalRewardAmount = data.data.totalRewardAmount; // 邀请收入总金额
          this.invitationUserCount = data.data.invitationUserCount; // 邀请总人数
          this.inviteUrl = data.data.inviteUrl; // 邀请链接URL
          this.inviteCode = data.data.inviteCode; // 邀请码
          this.rewardCoinSymbol = data.data.rewardCoinSymbol; // 邀请奖励币种
          this.rewardCoinSymbolList = data.data.rewardCoinSymbolList; // 邀请奖励币种下拉列表
          this.selectCoin = data.data.rewardCoinSymbol;
          this.miningGrantAmountByInvitation = data.data.miningGrantAmountByInvitation;
          this.miningGrantSymbol = data.data.miningGrantSymbol;
        }
      });
    },
    // 邀请列表数据
    getList() {
      this.axios({
        url: 'invitation/invitation_list',
        params: {
          rewardCoinSymbol: this.selectCoin,
          page: this.pagination.page,
          startTime: new Date(this.startTime.toLocaleDateString()).getTime(),
          // eslint-disable-next-line max-len
          endTime: new Date(new Date(this.endTime.toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1).getTime(),
          pageSize: this.pagination.pageSize,
        },
      }).then((data) => {
        if (data.code.toString() === '0') {
          this.pagination.count = data.data.count; // 邀请收入总金额
          this.onSolveList(data.data.list, 0);
        }
        this.tableLoading = false;
      });
    },
    // 处理表格数据
    onSolveList(returnList, type) {
      const list = [];
      if (returnList && returnList.length && type === 0) {
        returnList.forEach((item) => {
          list.push({
            id: JSON.stringify(item),
            classes: 'b-2-cl',
            data: [
              // 注册人uid
              item.registerUid,
              // 账户名
              item.userName,
              // KYC
              item.kycStatus,
              // 奖励状态
              item.sendRewardStatus === 0 ? this.$t('personal.myInvite.statusItem1') : this.$t('personal.myInvite.statusItem2'),
              // 邀请收入
              item.rewardAmount,
              // 币种
              item.rewardCoinSymbol,
              // 注册时间
              formatDateTime(item.registerTime),
            ],
          });
        });
      }
      if (returnList && returnList.length && type === 1) {
        returnList.forEach((item) => {
          list.push({
            id: JSON.stringify(item),
            classes: 'b-2-cl',
            data: [
              // 注册人uid
              item.registerUid,
              // 账户名
              item.userName,
              // KYC
              item.kycStatus,
              // 挖矿明细
              item.sendRewardStatus === 0 ? this.$t('personal.myInvite.statusItem1') : this.$t('personal.myInvite.statusItem2'),
              // 邀请挖矿奖励
              item.rewardAmount,
              // 注册时间
              formatDateTime(item.registerTime),
            ],
          });
        });
      }
      this.dataList = list;
    },
    // 挖矿返利
    getProfitsList() {
      this.tableLoading = true;
      this.axios({
        url: 'invitation/invitation_overview',
        params: {},
      }).then((data) => {
        if (data.code.toString() === '0') {
          this.pagination.count = data.data.count; // 邀请收入总金额
          this.onSolveList(data.data.list, 1);
        }
        this.tableLoading = false;
      });
    },
    // 翻页
    pagechange(num) {
      this.pagination.page = num;
      if (this.tableType === 'list') {
        this.getList();
      } else {
        this.getProfitsList();
      }
    },
  },
};
